import { wrapRootElement as wrapRoot } from './root-wrapper'
import { wrapPageElement as wrapPage } from './page-wrapper'

export const wrapRootElement = wrapRoot
export const wrapPageElement = wrapPage
